import { useMemo } from 'react';

import { useGetEvent, useGetNextEvent, useListEvents } from '@/api/generated';

const useCalendar = (from?: number, to?: number, eventId?: string) => {
  const {
    data: eventListResponse,
    refetch: refetchEvents,
    isLoading: eventListLoading
  } = useListEvents(
    { from, to },
    {
      query: {
        queryKey: ['listEvents', from, to],
        enabled: !!from
      }
    }
  );

  const eventList = useMemo(() => eventListResponse?.items || [], [eventListResponse?.items]);

  const {
    data: eventResponse,
    isLoading: eventLoading,
    isError: isEventError
  } = useGetEvent(eventId!, {
    query: {
      queryKey: ['getEvent', eventId],
      enabled: !!eventId
    }
  });

  const event = useMemo(() => eventResponse?.items?.[0] || undefined, [eventResponse?.items]);

  const {
    data: nextEventResponse,
    refetch: refetchNextEvent,
    isLoading: nextEventLoading
  } = useGetNextEvent();

  const nextEvent = useMemo(
    () => nextEventResponse?.items?.[0] || null,
    [nextEventResponse?.items]
  );

  return {
    eventList,
    eventListLoading,
    refetchEvents,
    nextEvent,
    refetchNextEvent,
    nextEventLoading,
    event,
    eventLoading,
    isEventError
  };
};

export default useCalendar;
